import { isScreenShareSupported } from '@/helpers/utils'
import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'

/**
 * returns whether the corresponding button should be visible and enabled
 * - button `visible` if one of the `capabilities` is enabled and the FF is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfScreenShareButtonState = () => {
  const selfScreenShareCapability = useCapabilitiesStore(
    state => state.selfScreenShareCapability,
  )
  const isFeatureDisabled = useFeaturesStore(
    state => state.disabled.ROOM_SHARE_SCREEN === FEATURES.ROOM_SHARE_SCREEN,
  )

  // button visible if capability is enabled, FF is enabled, and environment supports screen share
  const isScreenShareButtonVisible =
    !isFeatureDisabled && isScreenShareSupported() && selfScreenShareCapability

  // NOTE: screen share is special, in that it only depends on the capability
  const isScreenShareButtonEnabled = selfScreenShareCapability

  return { isScreenShareButtonEnabled, isScreenShareButtonVisible }
}
